import "./PackageTable.scss";
import DynamicCard from "./DynamicCard";

const DynamicPackageTable = ({
  orders = [],
  cancelOrder,
  allOrders,
  setOrders,
}) => {
  return (
    <div className="hotels-cards">
      {orders.map((row, index) => (
        <div key={index}>
          <DynamicCard
            orders={allOrders}
            setOrders={setOrders}
            cancelOrder={cancelOrder}
            key={row.id}
            row={row}
            index={index}
          />
        </div>
      ))}
    </div>
  );
};

export default DynamicPackageTable;
